import { nextArrow, prevArrow } from "../utilities/slick-arrows";

jQuery("[data-card-slider=latest-courses]").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    fade: false,
    autoplay: false,
    dots: false,
    // slide: '.course-card',
    rows: 0,
    focusOnSelect: true,
    prevArrow,
    nextArrow,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 860,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 525,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});
